/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.recipe.RecipeSurface
*/
export var RecipeSurface;
(function (RecipeSurface) {
    RecipeSurface["STANDARD"] = "STANDARD";
    RecipeSurface["EXPERT"] = "EXPERT";
})(RecipeSurface || (RecipeSurface = {}));
//# sourceMappingURL=RecipeSurface.js.map